import React from "react";

import Modal from "@stadium/ui/src/components/ModalNew";
import {
  ModalBody,
  ModalContent,
  ModalDialog,
  ModalHeader,
  CloseButton,
  ModalFooter,
} from "@stadium/ui/src/components/ModalNew/utils";
import Portal from "@stadium/ui/src/components/portal";

import { CONTACT_US } from "@stadium/constants/routes";
import Button, { LinkButton } from "components/shared/button";

import style from "./main.module.scss";

const PackageAssociatedModal = ({ closeModal, userData }) => {
  const { name, ownerUser } = userData || {};

  return (
    <Portal id="modal-root" dataContainerId="feature-packages">
      <Modal closeModal={closeModal} className={`${style.purchasePkg} modalOnboard`}>
        <ModalDialog className={style.modalDialog}>
          <ModalContent className={style.modalContent}>
            <ModalHeader className={style.modalHeader}>
              <div className={style.modalheaderContainer}>
                <h1 className={style.headingTitle}>
                  Your domain is associated with another account
                </h1>
                <CloseButton onClick={closeModal} className={style.closeModal} />
              </div>
            </ModalHeader>
            <ModalBody className={style.bodyContent}>
              <div className={style.mainHeading}>
                A Feature Package has already been purchased for your domain. To request access to
                the existing Company Space, contact the Account Admin below:
              </div>
              <div className={style.companyData}>
                <div className={style.companyName}>{name || "Company Name"}</div>
                {ownerUser?.email && <div>{ownerUser.email}</div>}
              </div>
              <div className={style.contactInfo}>
                If you have questions, please{" "}
                <LinkButton
                  className={style.contactSupportLink}
                  styleType="link"
                  href={CONTACT_US}
                  target="_blank"
                >
                  contact support.{" "}
                </LinkButton>
              </div>
            </ModalBody>
            <ModalFooter className={style.footerModal}>
              <Button className={style.closeBtn} onClick={closeModal} styleType="primary">
                Done
              </Button>
            </ModalFooter>
          </ModalContent>
        </ModalDialog>
      </Modal>
    </Portal>
  );
};

export default PackageAssociatedModal;
